import { useMutation } from 'react-query';
import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';
import { useStore } from '../../../../../store';

interface IProps {
    payload: FormData
}

export const useUploadBillFile = () => {
  const { customerId } = useStore(state => state.user);
  const { accountExternalId } = useStore(state => state.getPersonalAccount());
  return useMutation(
    'useUploadBillFile',
    async ({ payload }: IProps) => {
      const res = await httpService.post(
        `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/document/upload`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return res.data;
    },
  );
};
